/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { queryExecutionDashboardsDashboardIdPost$Json } from '../fn/query-execution/query-execution-dashboards-dashboard-id-post-json';
import { QueryExecutionDashboardsDashboardIdPost$Json$Params } from '../fn/query-execution/query-execution-dashboards-dashboard-id-post-json';
import { queryExecutionDashboardsDashboardIdPost$Plain } from '../fn/query-execution/query-execution-dashboards-dashboard-id-post-plain';
import { QueryExecutionDashboardsDashboardIdPost$Plain$Params } from '../fn/query-execution/query-execution-dashboards-dashboard-id-post-plain';
import { queryExecutionPreviewPost$Json } from '../fn/query-execution/query-execution-preview-post-json';
import { QueryExecutionPreviewPost$Json$Params } from '../fn/query-execution/query-execution-preview-post-json';
import { queryExecutionPreviewPost$Plain } from '../fn/query-execution/query-execution-preview-post-plain';
import { QueryExecutionPreviewPost$Plain$Params } from '../fn/query-execution/query-execution-preview-post-plain';
import { queryExecutionQueryDefinitionIdExecutePost$Json } from '../fn/query-execution/query-execution-query-definition-id-execute-post-json';
import { QueryExecutionQueryDefinitionIdExecutePost$Json$Params } from '../fn/query-execution/query-execution-query-definition-id-execute-post-json';
import { queryExecutionQueryDefinitionIdExecutePost$Plain } from '../fn/query-execution/query-execution-query-definition-id-execute-post-plain';
import { QueryExecutionQueryDefinitionIdExecutePost$Plain$Params } from '../fn/query-execution/query-execution-query-definition-id-execute-post-plain';
import { QueryResultDto } from '../models/query-result-dto';

@Injectable({ providedIn: 'root' })
export class QueryExecutionApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `queryExecutionQueryDefinitionIdExecutePost()` */
  static readonly QueryExecutionQueryDefinitionIdExecutePostPath = '/query-execution/{queryDefinitionId}/execute';

  /**
   * Execute saved query.
   *
   * Executes a saved query with optional filters/paging.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queryExecutionQueryDefinitionIdExecutePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queryExecutionQueryDefinitionIdExecutePost$Plain$Response(params: QueryExecutionQueryDefinitionIdExecutePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryResultDto>> {
    const obs = queryExecutionQueryDefinitionIdExecutePost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Execute saved query.
   *
   * Executes a saved query with optional filters/paging.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queryExecutionQueryDefinitionIdExecutePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queryExecutionQueryDefinitionIdExecutePost$Plain(params: QueryExecutionQueryDefinitionIdExecutePost$Plain$Params, context?: HttpContext): Observable<QueryResultDto> {
    const resp = this.queryExecutionQueryDefinitionIdExecutePost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryResultDto>): QueryResultDto => r.body)
    );
  }

  /**
   * Execute saved query.
   *
   * Executes a saved query with optional filters/paging.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queryExecutionQueryDefinitionIdExecutePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queryExecutionQueryDefinitionIdExecutePost$Json$Response(params: QueryExecutionQueryDefinitionIdExecutePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryResultDto>> {
    const obs = queryExecutionQueryDefinitionIdExecutePost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Execute saved query.
   *
   * Executes a saved query with optional filters/paging.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queryExecutionQueryDefinitionIdExecutePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queryExecutionQueryDefinitionIdExecutePost$Json(params: QueryExecutionQueryDefinitionIdExecutePost$Json$Params, context?: HttpContext): Observable<QueryResultDto> {
    const resp = this.queryExecutionQueryDefinitionIdExecutePost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryResultDto>): QueryResultDto => r.body)
    );
  }

  /** Path part for operation `queryExecutionPreviewPost()` */
  static readonly QueryExecutionPreviewPostPath = '/query-execution/preview';

  /**
   * Preview ad-hoc query.
   *
   * Executes a query definition from builder config without saving it.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queryExecutionPreviewPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queryExecutionPreviewPost$Plain$Response(params?: QueryExecutionPreviewPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryResultDto>> {
    const obs = queryExecutionPreviewPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Preview ad-hoc query.
   *
   * Executes a query definition from builder config without saving it.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queryExecutionPreviewPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queryExecutionPreviewPost$Plain(params?: QueryExecutionPreviewPost$Plain$Params, context?: HttpContext): Observable<QueryResultDto> {
    const resp = this.queryExecutionPreviewPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryResultDto>): QueryResultDto => r.body)
    );
  }

  /**
   * Preview ad-hoc query.
   *
   * Executes a query definition from builder config without saving it.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queryExecutionPreviewPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queryExecutionPreviewPost$Json$Response(params?: QueryExecutionPreviewPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryResultDto>> {
    const obs = queryExecutionPreviewPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Preview ad-hoc query.
   *
   * Executes a query definition from builder config without saving it.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queryExecutionPreviewPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queryExecutionPreviewPost$Json(params?: QueryExecutionPreviewPost$Json$Params, context?: HttpContext): Observable<QueryResultDto> {
    const resp = this.queryExecutionPreviewPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryResultDto>): QueryResultDto => r.body)
    );
  }

  /** Path part for operation `queryExecutionDashboardsDashboardIdPost()` */
  static readonly QueryExecutionDashboardsDashboardIdPostPath = '/query-execution/dashboards/{dashboardId}';

  /**
   * Execute dashboard.
   *
   * Executes all tiles for a dashboard and returns a list of results.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queryExecutionDashboardsDashboardIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queryExecutionDashboardsDashboardIdPost$Plain$Response(params: QueryExecutionDashboardsDashboardIdPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<QueryResultDto>>> {
    const obs = queryExecutionDashboardsDashboardIdPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Execute dashboard.
   *
   * Executes all tiles for a dashboard and returns a list of results.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queryExecutionDashboardsDashboardIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queryExecutionDashboardsDashboardIdPost$Plain(params: QueryExecutionDashboardsDashboardIdPost$Plain$Params, context?: HttpContext): Observable<Array<QueryResultDto>> {
    const resp = this.queryExecutionDashboardsDashboardIdPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<QueryResultDto>>): Array<QueryResultDto> => r.body)
    );
  }

  /**
   * Execute dashboard.
   *
   * Executes all tiles for a dashboard and returns a list of results.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queryExecutionDashboardsDashboardIdPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queryExecutionDashboardsDashboardIdPost$Json$Response(params: QueryExecutionDashboardsDashboardIdPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<QueryResultDto>>> {
    const obs = queryExecutionDashboardsDashboardIdPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Execute dashboard.
   *
   * Executes all tiles for a dashboard and returns a list of results.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queryExecutionDashboardsDashboardIdPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queryExecutionDashboardsDashboardIdPost$Json(params: QueryExecutionDashboardsDashboardIdPost$Json$Params, context?: HttpContext): Observable<Array<QueryResultDto>> {
    const resp = this.queryExecutionDashboardsDashboardIdPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<QueryResultDto>>): Array<QueryResultDto> => r.body)
    );
  }

}
